(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlText', [])
        .directive('dynamicText', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-text/custom-control-text-template.html',
                controller: [
                    '$scope', '$filter', function ($scope, $filter) {
                        $scope.mask = $scope.data.mask;
                    }
                ]
            };
        });

    angular.module('CustomControlText')
       .directive('dynamicFilterText', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-text/custom-control-filter-text-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'EqualIgnoreCase';
                       }
                       $scope.mask = $scope.data.mask;
                   }
               ]
           };
       }]);
})();